// Comprehensive world currency detection and conversion utility
// Supports all ISO 4217 currencies

// Complete mapping of country codes to currencies (ALL countries)
export const CURRENCY_BY_COUNTRY = {
  // Africa
  DZ: { code: 'DZD', symbol: 'د.ج', name: 'Algerian Dinar' },
  AO: { code: 'AOA', symbol: 'Kz', name: 'Angolan Kwanza' },
  BJ: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  BW: { code: 'BWP', symbol: 'P', name: 'Botswana Pula' },
  BF: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  BI: { code: 'BIF', symbol: 'FBu', name: 'Burundian Franc' },
  CV: { code: 'CVE', symbol: '$', name: 'Cape Verdean Escudo' },
  CM: { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  CF: { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  TD: { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  KM: { code: 'KMF', symbol: 'CF', name: 'Comorian Franc' },
  CG: { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  CD: { code: 'CDF', symbol: 'FC', name: 'Congolese Franc' },
  CI: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  DJ: { code: 'DJF', symbol: 'Fdj', name: 'Djiboutian Franc' },
  EG: { code: 'EGP', symbol: 'E£', name: 'Egyptian Pound' },
  GQ: { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  ER: { code: 'ERN', symbol: 'Nfk', name: 'Eritrean Nakfa' },
  SZ: { code: 'SZL', symbol: 'E', name: 'Swazi Lilangeni' },
  ET: { code: 'ETB', symbol: 'Br', name: 'Ethiopian Birr' },
  GA: { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc' },
  GM: { code: 'GMD', symbol: 'D', name: 'Gambian Dalasi' },
  GH: { code: 'GHS', symbol: 'GH₵', name: 'Ghanaian Cedi' },
  GN: { code: 'GNF', symbol: 'FG', name: 'Guinean Franc' },
  GW: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  KE: { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling' },
  LS: { code: 'LSL', symbol: 'M', name: 'Lesotho Loti' },
  LR: { code: 'LRD', symbol: 'L$', name: 'Liberian Dollar' },
  LY: { code: 'LYD', symbol: 'ل.د', name: 'Libyan Dinar' },
  MG: { code: 'MGA', symbol: 'Ar', name: 'Malagasy Ariary' },
  MW: { code: 'MWK', symbol: 'MK', name: 'Malawian Kwacha' },
  ML: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  MR: { code: 'MRU', symbol: 'UM', name: 'Mauritanian Ouguiya' },
  MU: { code: 'MUR', symbol: '₨', name: 'Mauritian Rupee' },
  MA: { code: 'MAD', symbol: 'د.م.', name: 'Moroccan Dirham' },
  MZ: { code: 'MZN', symbol: 'MT', name: 'Mozambican Metical' },
  NA: { code: 'NAD', symbol: 'N$', name: 'Namibian Dollar' },
  NE: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  NG: { code: 'NGN', symbol: '₦', name: 'Nigerian Naira' },
  RW: { code: 'RWF', symbol: 'FRw', name: 'Rwandan Franc' },
  ST: { code: 'STN', symbol: 'Db', name: 'São Tomé and Príncipe Dobra' },
  SN: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  SC: { code: 'SCR', symbol: '₨', name: 'Seychellois Rupee' },
  SL: { code: 'SLE', symbol: 'Le', name: 'Sierra Leonean Leone' },
  SO: { code: 'SOS', symbol: 'S', name: 'Somali Shilling' },
  ZA: { code: 'ZAR', symbol: 'R', name: 'South African Rand' },
  SS: { code: 'SSP', symbol: '£', name: 'South Sudanese Pound' },
  SD: { code: 'SDG', symbol: 'ج.س.', name: 'Sudanese Pound' },
  TZ: { code: 'TZS', symbol: 'TSh', name: 'Tanzanian Shilling' },
  TG: { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc' },
  TN: { code: 'TND', symbol: 'د.ت', name: 'Tunisian Dinar' },
  UG: { code: 'UGX', symbol: 'USh', name: 'Ugandan Shilling' },
  ZM: { code: 'ZMW', symbol: 'ZK', name: 'Zambian Kwacha' },
  ZW: { code: 'ZWL', symbol: 'Z$', name: 'Zimbabwean Dollar' },

  // Asia
  AF: { code: 'AFN', symbol: '؋', name: 'Afghan Afghani' },
  AM: { code: 'AMD', symbol: '֏', name: 'Armenian Dram' },
  AZ: { code: 'AZN', symbol: '₼', name: 'Azerbaijani Manat' },
  BH: { code: 'BHD', symbol: '.د.ب', name: 'Bahraini Dinar' },
  BD: { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka' },
  BT: { code: 'BTN', symbol: 'Nu.', name: 'Bhutanese Ngultrum' },
  BN: { code: 'BND', symbol: 'B$', name: 'Brunei Dollar' },
  KH: { code: 'KHR', symbol: '៛', name: 'Cambodian Riel' },
  CN: { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  CY: { code: 'EUR', symbol: '€', name: 'Euro' },
  GE: { code: 'GEL', symbol: '₾', name: 'Georgian Lari' },
  HK: { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar' },
  IN: { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  ID: { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah' },
  IR: { code: 'IRR', symbol: '﷼', name: 'Iranian Rial' },
  IQ: { code: 'IQD', symbol: 'ع.د', name: 'Iraqi Dinar' },
  IL: { code: 'ILS', symbol: '₪', name: 'Israeli New Shekel' },
  JP: { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  JO: { code: 'JOD', symbol: 'د.ا', name: 'Jordanian Dinar' },
  KZ: { code: 'KZT', symbol: '₸', name: 'Kazakhstani Tenge' },
  KW: { code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti Dinar' },
  KG: { code: 'KGS', symbol: 'с', name: 'Kyrgyzstani Som' },
  LA: { code: 'LAK', symbol: '₭', name: 'Lao Kip' },
  LB: { code: 'LBP', symbol: 'ل.ل', name: 'Lebanese Pound' },
  MO: { code: 'MOP', symbol: 'MOP$', name: 'Macanese Pataca' },
  MY: { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit' },
  MV: { code: 'MVR', symbol: 'Rf', name: 'Maldivian Rufiyaa' },
  MN: { code: 'MNT', symbol: '₮', name: 'Mongolian Tögrög' },
  MM: { code: 'MMK', symbol: 'K', name: 'Myanmar Kyat' },
  NP: { code: 'NPR', symbol: 'रू', name: 'Nepalese Rupee' },
  KP: { code: 'KPW', symbol: '₩', name: 'North Korean Won' },
  OM: { code: 'OMR', symbol: 'ر.ع.', name: 'Omani Rial' },
  PK: { code: 'PKR', symbol: '₨', name: 'Pakistani Rupee' },
  PS: { code: 'ILS', symbol: '₪', name: 'Israeli New Shekel' },
  PH: { code: 'PHP', symbol: '₱', name: 'Philippine Peso' },
  QA: { code: 'QAR', symbol: 'ر.ق', name: 'Qatari Riyal' },
  SA: { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal' },
  SG: { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  KR: { code: 'KRW', symbol: '₩', name: 'South Korean Won' },
  LK: { code: 'LKR', symbol: 'Rs', name: 'Sri Lankan Rupee' },
  SY: { code: 'SYP', symbol: '£S', name: 'Syrian Pound' },
  TW: { code: 'TWD', symbol: 'NT$', name: 'New Taiwan Dollar' },
  TJ: { code: 'TJS', symbol: 'SM', name: 'Tajikistani Somoni' },
  TH: { code: 'THB', symbol: '฿', name: 'Thai Baht' },
  TL: { code: 'USD', symbol: '$', name: 'US Dollar' },
  TR: { code: 'TRY', symbol: '₺', name: 'Turkish Lira' },
  TM: { code: 'TMT', symbol: 'm', name: 'Turkmenistani Manat' },
  AE: { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  UZ: { code: 'UZS', symbol: "so'm", name: 'Uzbekistani Som' },
  VN: { code: 'VND', symbol: '₫', name: 'Vietnamese Đồng' },
  YE: { code: 'YER', symbol: '﷼', name: 'Yemeni Rial' },

  // Europe
  AL: { code: 'ALL', symbol: 'L', name: 'Albanian Lek' },
  AD: { code: 'EUR', symbol: '€', name: 'Euro' },
  AT: { code: 'EUR', symbol: '€', name: 'Euro' },
  BY: { code: 'BYN', symbol: 'Br', name: 'Belarusian Ruble' },
  BE: { code: 'EUR', symbol: '€', name: 'Euro' },
  BA: { code: 'BAM', symbol: 'KM', name: 'Bosnia and Herzegovina Convertible Mark' },
  BG: { code: 'BGN', symbol: 'лв', name: 'Bulgarian Lev' },
  HR: { code: 'EUR', symbol: '€', name: 'Euro' },
  CZ: { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna' },
  DK: { code: 'DKK', symbol: 'kr', name: 'Danish Krone' },
  EE: { code: 'EUR', symbol: '€', name: 'Euro' },
  FI: { code: 'EUR', symbol: '€', name: 'Euro' },
  FR: { code: 'EUR', symbol: '€', name: 'Euro' },
  DE: { code: 'EUR', symbol: '€', name: 'Euro' },
  GR: { code: 'EUR', symbol: '€', name: 'Euro' },
  HU: { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint' },
  IS: { code: 'ISK', symbol: 'kr', name: 'Icelandic Króna' },
  IE: { code: 'EUR', symbol: '€', name: 'Euro' },
  IT: { code: 'EUR', symbol: '€', name: 'Euro' },
  XK: { code: 'EUR', symbol: '€', name: 'Euro' },
  LV: { code: 'EUR', symbol: '€', name: 'Euro' },
  LI: { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  LT: { code: 'EUR', symbol: '€', name: 'Euro' },
  LU: { code: 'EUR', symbol: '€', name: 'Euro' },
  MT: { code: 'EUR', symbol: '€', name: 'Euro' },
  MD: { code: 'MDL', symbol: 'L', name: 'Moldovan Leu' },
  MC: { code: 'EUR', symbol: '€', name: 'Euro' },
  ME: { code: 'EUR', symbol: '€', name: 'Euro' },
  NL: { code: 'EUR', symbol: '€', name: 'Euro' },
  MK: { code: 'MKD', symbol: 'ден', name: 'Macedonian Denar' },
  NO: { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone' },
  PL: { code: 'PLN', symbol: 'zł', name: 'Polish Złoty' },
  PT: { code: 'EUR', symbol: '€', name: 'Euro' },
  RO: { code: 'RON', symbol: 'lei', name: 'Romanian Leu' },
  RU: { code: 'RUB', symbol: '₽', name: 'Russian Ruble' },
  SM: { code: 'EUR', symbol: '€', name: 'Euro' },
  RS: { code: 'RSD', symbol: 'дин.', name: 'Serbian Dinar' },
  SK: { code: 'EUR', symbol: '€', name: 'Euro' },
  SI: { code: 'EUR', symbol: '€', name: 'Euro' },
  ES: { code: 'EUR', symbol: '€', name: 'Euro' },
  SE: { code: 'SEK', symbol: 'kr', name: 'Swedish Krona' },
  CH: { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  UA: { code: 'UAH', symbol: '₴', name: 'Ukrainian Hryvnia' },
  GB: { code: 'GBP', symbol: '£', name: 'British Pound' },
  VA: { code: 'EUR', symbol: '€', name: 'Euro' },

  // North America
  AG: { code: 'XCD', symbol: 'EC$', name: 'East Caribbean Dollar' },
  BS: { code: 'BSD', symbol: 'B$', name: 'Bahamian Dollar' },
  BB: { code: 'BBD', symbol: 'Bds$', name: 'Barbadian Dollar' },
  BZ: { code: 'BZD', symbol: 'BZ$', name: 'Belize Dollar' },
  CA: { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  CR: { code: 'CRC', symbol: '₡', name: 'Costa Rican Colón' },
  CU: { code: 'CUP', symbol: '₱', name: 'Cuban Peso' },
  DM: { code: 'XCD', symbol: 'EC$', name: 'East Caribbean Dollar' },
  DO: { code: 'DOP', symbol: 'RD$', name: 'Dominican Peso' },
  SV: { code: 'USD', symbol: '$', name: 'US Dollar' },
  GD: { code: 'XCD', symbol: 'EC$', name: 'East Caribbean Dollar' },
  GT: { code: 'GTQ', symbol: 'Q', name: 'Guatemalan Quetzal' },
  HT: { code: 'HTG', symbol: 'G', name: 'Haitian Gourde' },
  HN: { code: 'HNL', symbol: 'L', name: 'Honduran Lempira' },
  JM: { code: 'JMD', symbol: 'J$', name: 'Jamaican Dollar' },
  MX: { code: 'MXN', symbol: 'MX$', name: 'Mexican Peso' },
  NI: { code: 'NIO', symbol: 'C$', name: 'Nicaraguan Córdoba' },
  PA: { code: 'PAB', symbol: 'B/.', name: 'Panamanian Balboa' },
  KN: { code: 'XCD', symbol: 'EC$', name: 'East Caribbean Dollar' },
  LC: { code: 'XCD', symbol: 'EC$', name: 'East Caribbean Dollar' },
  VC: { code: 'XCD', symbol: 'EC$', name: 'East Caribbean Dollar' },
  TT: { code: 'TTD', symbol: 'TT$', name: 'Trinidad and Tobago Dollar' },
  US: { code: 'USD', symbol: '$', name: 'US Dollar' },

  // South America
  AR: { code: 'ARS', symbol: '$', name: 'Argentine Peso' },
  BO: { code: 'BOB', symbol: 'Bs.', name: 'Bolivian Boliviano' },
  BR: { code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  CL: { code: 'CLP', symbol: '$', name: 'Chilean Peso' },
  CO: { code: 'COP', symbol: '$', name: 'Colombian Peso' },
  EC: { code: 'USD', symbol: '$', name: 'US Dollar' },
  GY: { code: 'GYD', symbol: 'G$', name: 'Guyanese Dollar' },
  PY: { code: 'PYG', symbol: '₲', name: 'Paraguayan Guaraní' },
  PE: { code: 'PEN', symbol: 'S/', name: 'Peruvian Sol' },
  SR: { code: 'SRD', symbol: '$', name: 'Surinamese Dollar' },
  UY: { code: 'UYU', symbol: '$U', name: 'Uruguayan Peso' },
  VE: { code: 'VES', symbol: 'Bs.S', name: 'Venezuelan Bolívar' },

  // Oceania
  AU: { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  FJ: { code: 'FJD', symbol: 'FJ$', name: 'Fijian Dollar' },
  KI: { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  MH: { code: 'USD', symbol: '$', name: 'US Dollar' },
  FM: { code: 'USD', symbol: '$', name: 'US Dollar' },
  NR: { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  NZ: { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar' },
  PW: { code: 'USD', symbol: '$', name: 'US Dollar' },
  PG: { code: 'PGK', symbol: 'K', name: 'Papua New Guinean Kina' },
  WS: { code: 'WST', symbol: 'WS$', name: 'Samoan Tālā' },
  SB: { code: 'SBD', symbol: 'SI$', name: 'Solomon Islands Dollar' },
  TO: { code: 'TOP', symbol: 'T$', name: "Tongan Pa'anga" },
  TV: { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  VU: { code: 'VUV', symbol: 'VT', name: 'Vanuatu Vatu' },

  // Caribbean & Others
  AW: { code: 'AWG', symbol: 'ƒ', name: 'Aruban Florin' },
  BM: { code: 'BMD', symbol: '$', name: 'Bermudian Dollar' },
  KY: { code: 'KYD', symbol: 'CI$', name: 'Cayman Islands Dollar' },
  CW: { code: 'ANG', symbol: 'ƒ', name: 'Netherlands Antillean Guilder' },
  FK: { code: 'FKP', symbol: '£', name: 'Falkland Islands Pound' },
  GI: { code: 'GIP', symbol: '£', name: 'Gibraltar Pound' },
  GL: { code: 'DKK', symbol: 'kr', name: 'Danish Krone' },
  GP: { code: 'EUR', symbol: '€', name: 'Euro' },
  GU: { code: 'USD', symbol: '$', name: 'US Dollar' },
  MQ: { code: 'EUR', symbol: '€', name: 'Euro' },
  NC: { code: 'XPF', symbol: '₣', name: 'CFP Franc' },
  PR: { code: 'USD', symbol: '$', name: 'US Dollar' },
  RE: { code: 'EUR', symbol: '€', name: 'Euro' },
  SX: { code: 'ANG', symbol: 'ƒ', name: 'Netherlands Antillean Guilder' },
  TC: { code: 'USD', symbol: '$', name: 'US Dollar' },
  VI: { code: 'USD', symbol: '$', name: 'US Dollar' },
  VG: { code: 'USD', symbol: '$', name: 'US Dollar' },
};

// All unique currency codes for formatting
export const ALL_CURRENCIES = {
  USD: { symbol: '$', name: 'US Dollar', decimals: 2 },
  EUR: { symbol: '€', name: 'Euro', decimals: 2 },
  GBP: { symbol: '£', name: 'British Pound', decimals: 2 },
  JPY: { symbol: '¥', name: 'Japanese Yen', decimals: 0 },
  CNY: { symbol: '¥', name: 'Chinese Yuan', decimals: 2 },
  INR: { symbol: '₹', name: 'Indian Rupee', decimals: 2 },
  AUD: { symbol: 'A$', name: 'Australian Dollar', decimals: 2 },
  CAD: { symbol: 'C$', name: 'Canadian Dollar', decimals: 2 },
  CHF: { symbol: 'CHF', name: 'Swiss Franc', decimals: 2 },
  HKD: { symbol: 'HK$', name: 'Hong Kong Dollar', decimals: 2 },
  SGD: { symbol: 'S$', name: 'Singapore Dollar', decimals: 2 },
  SEK: { symbol: 'kr', name: 'Swedish Krona', decimals: 2 },
  KRW: { symbol: '₩', name: 'South Korean Won', decimals: 0 },
  NOK: { symbol: 'kr', name: 'Norwegian Krone', decimals: 2 },
  NZD: { symbol: 'NZ$', name: 'New Zealand Dollar', decimals: 2 },
  MXN: { symbol: 'MX$', name: 'Mexican Peso', decimals: 2 },
  BRL: { symbol: 'R$', name: 'Brazilian Real', decimals: 2 },
  ZAR: { symbol: 'R', name: 'South African Rand', decimals: 2 },
  RUB: { symbol: '₽', name: 'Russian Ruble', decimals: 2 },
  TRY: { symbol: '₺', name: 'Turkish Lira', decimals: 2 },
  PLN: { symbol: 'zł', name: 'Polish Złoty', decimals: 2 },
  THB: { symbol: '฿', name: 'Thai Baht', decimals: 2 },
  IDR: { symbol: 'Rp', name: 'Indonesian Rupiah', decimals: 0 },
  HUF: { symbol: 'Ft', name: 'Hungarian Forint', decimals: 0 },
  CZK: { symbol: 'Kč', name: 'Czech Koruna', decimals: 2 },
  ILS: { symbol: '₪', name: 'Israeli New Shekel', decimals: 2 },
  CLP: { symbol: '$', name: 'Chilean Peso', decimals: 0 },
  PHP: { symbol: '₱', name: 'Philippine Peso', decimals: 2 },
  AED: { symbol: 'د.إ', name: 'UAE Dirham', decimals: 2 },
  COP: { symbol: '$', name: 'Colombian Peso', decimals: 0 },
  SAR: { symbol: '﷼', name: 'Saudi Riyal', decimals: 2 },
  MYR: { symbol: 'RM', name: 'Malaysian Ringgit', decimals: 2 },
  RON: { symbol: 'lei', name: 'Romanian Leu', decimals: 2 },
  NGN: { symbol: '₦', name: 'Nigerian Naira', decimals: 2 },
  ARS: { symbol: '$', name: 'Argentine Peso', decimals: 2 },
  UAH: { symbol: '₴', name: 'Ukrainian Hryvnia', decimals: 2 },
  VND: { symbol: '₫', name: 'Vietnamese Đồng', decimals: 0 },
  EGP: { symbol: 'E£', name: 'Egyptian Pound', decimals: 2 },
  DKK: { symbol: 'kr', name: 'Danish Krone', decimals: 2 },
  PKR: { symbol: '₨', name: 'Pakistani Rupee', decimals: 2 },
  KES: { symbol: 'KSh', name: 'Kenyan Shilling', decimals: 2 },
  GHS: { symbol: 'GH₵', name: 'Ghanaian Cedi', decimals: 2 },
  BDT: { symbol: '৳', name: 'Bangladeshi Taka', decimals: 2 },
  QAR: { symbol: 'ر.ق', name: 'Qatari Riyal', decimals: 2 },
  KWD: { symbol: 'د.ك', name: 'Kuwaiti Dinar', decimals: 3 },
  BHD: { symbol: '.د.ب', name: 'Bahraini Dinar', decimals: 3 },
  OMR: { symbol: 'ر.ع.', name: 'Omani Rial', decimals: 3 },
  JOD: { symbol: 'د.ا', name: 'Jordanian Dinar', decimals: 3 },
  IQD: { symbol: 'ع.د', name: 'Iraqi Dinar', decimals: 0 },
  LKR: { symbol: 'Rs', name: 'Sri Lankan Rupee', decimals: 2 },
  MMK: { symbol: 'K', name: 'Myanmar Kyat', decimals: 0 },
  NPR: { symbol: 'रू', name: 'Nepalese Rupee', decimals: 2 },
  TWD: { symbol: 'NT$', name: 'New Taiwan Dollar', decimals: 0 },
  MAD: { symbol: 'د.م.', name: 'Moroccan Dirham', decimals: 2 },
  DZD: { symbol: 'د.ج', name: 'Algerian Dinar', decimals: 2 },
  TND: { symbol: 'د.ت', name: 'Tunisian Dinar', decimals: 3 },
  PEN: { symbol: 'S/', name: 'Peruvian Sol', decimals: 2 },
  UGX: { symbol: 'USh', name: 'Ugandan Shilling', decimals: 0 },
  TZS: { symbol: 'TSh', name: 'Tanzanian Shilling', decimals: 0 },
  XOF: { symbol: 'CFA', name: 'West African CFA Franc', decimals: 0 },
  XAF: { symbol: 'FCFA', name: 'Central African CFA Franc', decimals: 0 },
  ETB: { symbol: 'Br', name: 'Ethiopian Birr', decimals: 2 },
  AOA: { symbol: 'Kz', name: 'Angolan Kwanza', decimals: 2 },
  ZMW: { symbol: 'ZK', name: 'Zambian Kwacha', decimals: 2 },
  BWP: { symbol: 'P', name: 'Botswana Pula', decimals: 2 },
  MUR: { symbol: '₨', name: 'Mauritian Rupee', decimals: 2 },
  NAD: { symbol: 'N$', name: 'Namibian Dollar', decimals: 2 },
  RWF: { symbol: 'FRw', name: 'Rwandan Franc', decimals: 0 },
  MZN: { symbol: 'MT', name: 'Mozambican Metical', decimals: 2 },
  CDF: { symbol: 'FC', name: 'Congolese Franc', decimals: 2 },
  XCD: { symbol: 'EC$', name: 'East Caribbean Dollar', decimals: 2 },
  BSD: { symbol: 'B$', name: 'Bahamian Dollar', decimals: 2 },
  BBD: { symbol: 'Bds$', name: 'Barbadian Dollar', decimals: 2 },
  JMD: { symbol: 'J$', name: 'Jamaican Dollar', decimals: 2 },
  TTD: { symbol: 'TT$', name: 'Trinidad and Tobago Dollar', decimals: 2 },
  DOP: { symbol: 'RD$', name: 'Dominican Peso', decimals: 2 },
  GTQ: { symbol: 'Q', name: 'Guatemalan Quetzal', decimals: 2 },
  HNL: { symbol: 'L', name: 'Honduran Lempira', decimals: 2 },
  NIO: { symbol: 'C$', name: 'Nicaraguan Córdoba', decimals: 2 },
  CRC: { symbol: '₡', name: 'Costa Rican Colón', decimals: 0 },
  PAB: { symbol: 'B/.', name: 'Panamanian Balboa', decimals: 2 },
  BOB: { symbol: 'Bs.', name: 'Bolivian Boliviano', decimals: 2 },
  PYG: { symbol: '₲', name: 'Paraguayan Guaraní', decimals: 0 },
  UYU: { symbol: '$U', name: 'Uruguayan Peso', decimals: 2 },
  VES: { symbol: 'Bs.S', name: 'Venezuelan Bolívar', decimals: 2 },
  GYD: { symbol: 'G$', name: 'Guyanese Dollar', decimals: 2 },
  SRD: { symbol: '$', name: 'Surinamese Dollar', decimals: 2 },
  FJD: { symbol: 'FJ$', name: 'Fijian Dollar', decimals: 2 },
  PGK: { symbol: 'K', name: 'Papua New Guinean Kina', decimals: 2 },
  SBD: { symbol: 'SI$', name: 'Solomon Islands Dollar', decimals: 2 },
  VUV: { symbol: 'VT', name: 'Vanuatu Vatu', decimals: 0 },
  WST: { symbol: 'WS$', name: 'Samoan Tālā', decimals: 2 },
  TOP: { symbol: 'T$', name: "Tongan Pa'anga", decimals: 2 },
  KHR: { symbol: '៛', name: 'Cambodian Riel', decimals: 0 },
  LAK: { symbol: '₭', name: 'Lao Kip', decimals: 0 },
  MNT: { symbol: '₮', name: 'Mongolian Tögrög', decimals: 0 },
  KZT: { symbol: '₸', name: 'Kazakhstani Tenge', decimals: 2 },
  UZS: { symbol: "so'm", name: 'Uzbekistani Som', decimals: 0 },
  GEL: { symbol: '₾', name: 'Georgian Lari', decimals: 2 },
  AMD: { symbol: '֏', name: 'Armenian Dram', decimals: 0 },
  AZN: { symbol: '₼', name: 'Azerbaijani Manat', decimals: 2 },
  BYN: { symbol: 'Br', name: 'Belarusian Ruble', decimals: 2 },
  MDL: { symbol: 'L', name: 'Moldovan Leu', decimals: 2 },
  ALL: { symbol: 'L', name: 'Albanian Lek', decimals: 0 },
  MKD: { symbol: 'ден', name: 'Macedonian Denar', decimals: 2 },
  RSD: { symbol: 'дин.', name: 'Serbian Dinar', decimals: 0 },
  BAM: { symbol: 'KM', name: 'Bosnia-Herzegovina Mark', decimals: 2 },
  BGN: { symbol: 'лв', name: 'Bulgarian Lev', decimals: 2 },
  ISK: { symbol: 'kr', name: 'Icelandic Króna', decimals: 0 },
  BND: { symbol: 'B$', name: 'Brunei Dollar', decimals: 2 },
  MVR: { symbol: 'Rf', name: 'Maldivian Rufiyaa', decimals: 2 },
  BTN: { symbol: 'Nu.', name: 'Bhutanese Ngultrum', decimals: 2 },
  AFN: { symbol: '؋', name: 'Afghan Afghani', decimals: 0 },
  IRR: { symbol: '﷼', name: 'Iranian Rial', decimals: 0 },
  SYP: { symbol: '£S', name: 'Syrian Pound', decimals: 0 },
  LBP: { symbol: 'ل.ل', name: 'Lebanese Pound', decimals: 0 },
  YER: { symbol: '﷼', name: 'Yemeni Rial', decimals: 0 },
  LYD: { symbol: 'ل.د', name: 'Libyan Dinar', decimals: 3 },
  SDG: { symbol: 'ج.س.', name: 'Sudanese Pound', decimals: 2 },
  SSP: { symbol: '£', name: 'South Sudanese Pound', decimals: 2 },
  SOS: { symbol: 'S', name: 'Somali Shilling', decimals: 0 },
  ERN: { symbol: 'Nfk', name: 'Eritrean Nakfa', decimals: 2 },
  DJF: { symbol: 'Fdj', name: 'Djiboutian Franc', decimals: 0 },
  KMF: { symbol: 'CF', name: 'Comorian Franc', decimals: 0 },
  MGA: { symbol: 'Ar', name: 'Malagasy Ariary', decimals: 0 },
  SCR: { symbol: '₨', name: 'Seychellois Rupee', decimals: 2 },
  MWK: { symbol: 'MK', name: 'Malawian Kwacha', decimals: 2 },
  SZL: { symbol: 'E', name: 'Swazi Lilangeni', decimals: 2 },
  LSL: { symbol: 'M', name: 'Lesotho Loti', decimals: 2 },
  GMD: { symbol: 'D', name: 'Gambian Dalasi', decimals: 2 },
  GNF: { symbol: 'FG', name: 'Guinean Franc', decimals: 0 },
  SLE: { symbol: 'Le', name: 'Sierra Leonean Leone', decimals: 2 },
  LRD: { symbol: 'L$', name: 'Liberian Dollar', decimals: 2 },
  CVE: { symbol: '$', name: 'Cape Verdean Escudo', decimals: 0 },
  STN: { symbol: 'Db', name: 'São Tomé Príncipe Dobra', decimals: 2 },
  BIF: { symbol: 'FBu', name: 'Burundian Franc', decimals: 0 },
  MRU: { symbol: 'UM', name: 'Mauritanian Ouguiya', decimals: 2 },
  ZWL: { symbol: 'Z$', name: 'Zimbabwean Dollar', decimals: 2 },
  CUP: { symbol: '₱', name: 'Cuban Peso', decimals: 2 },
  HTG: { symbol: 'G', name: 'Haitian Gourde', decimals: 2 },
  BZD: { symbol: 'BZ$', name: 'Belize Dollar', decimals: 2 },
  AWG: { symbol: 'ƒ', name: 'Aruban Florin', decimals: 2 },
  ANG: { symbol: 'ƒ', name: 'Netherlands Antillean Guilder', decimals: 2 },
  KYD: { symbol: 'CI$', name: 'Cayman Islands Dollar', decimals: 2 },
  BMD: { symbol: '$', name: 'Bermudian Dollar', decimals: 2 },
  FKP: { symbol: '£', name: 'Falkland Islands Pound', decimals: 2 },
  GIP: { symbol: '£', name: 'Gibraltar Pound', decimals: 2 },
  XPF: { symbol: '₣', name: 'CFP Franc', decimals: 0 },
  MOP: { symbol: 'MOP$', name: 'Macanese Pataca', decimals: 2 },
  KPW: { symbol: '₩', name: 'North Korean Won', decimals: 0 },
  TJS: { symbol: 'SM', name: 'Tajikistani Somoni', decimals: 2 },
  KGS: { symbol: 'с', name: 'Kyrgyzstani Som', decimals: 2 },
  TMT: { symbol: 'm', name: 'Turkmenistani Manat', decimals: 2 },
};

// Gateway supported currencies
export const GATEWAY_CURRENCIES = {
  stripe: ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'RON', 'BGN', 'HRK', 'NZD', 'SGD', 'HKD', 'MXN', 'BRL', 'INR', 'MYR', 'THB', 'PHP', 'IDR', 'TWD', 'AED', 'SAR', 'ZAR', 'NGN', 'EGP', 'KES', 'TZS', 'UGX', 'GHS', 'MAD'],
  paystack: ['NGN', 'GHS', 'ZAR', 'KES', 'USD'],
  flutterwave: ['NGN', 'GHS', 'KES', 'ZAR', 'TZS', 'UGX', 'RWF', 'USD', 'EUR', 'GBP', 'XOF', 'XAF'],
  korapay: ['NGN', 'GHS', 'KES'],
  monnify: ['NGN'],
  paypal: ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'NZD', 'SGD', 'HKD', 'MXN', 'BRL', 'ILS', 'PHP', 'TWD', 'THB', 'MYR', 'RUB'],
  paysafe: ['NGN'],
};

// Cache for exchange rates
let exchangeRatesCache = null;
let ratesCacheTime = 0;
const CACHE_DURATION = 10 * 1000; // 10 seconds - keep rates fresh

// Silently detect user location
export const detectUserLocation = async (forceRefresh = false) => {
  try {
    // Check localStorage first (unless force refresh)
    if (!forceRefresh) {
      const cached = localStorage.getItem('userLocation');
      if (cached) {
        const parsed = JSON.parse(cached);
        // Cache for 10 seconds only
        if (Date.now() - parsed.timestamp < 10 * 1000) {
          return parsed.data;
        }
      }
    }

    // Use backend API to avoid CORS issues
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const response = await fetch(`${backendUrl}/api/detect-location`, { 
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    });
    
    if (response.ok) {
      const data = await response.json();
      const currencyData = CURRENCY_BY_COUNTRY[data.country_code];
      const result = {
        countryCode: data.country_code,
        country: data.country,
        currency: currencyData || { 
          code: data.currency_code || 'USD', 
          symbol: ALL_CURRENCIES[data.currency_code]?.symbol || '$', 
          name: ALL_CURRENCIES[data.currency_code]?.name || 'US Dollar' 
        }
      };

      // Cache result
      localStorage.setItem('userLocation', JSON.stringify({ data: result, timestamp: Date.now() }));
      return result;
    }
    
    throw new Error('Backend location detection failed');
  } catch (error) {
    // Silent fail - return default
    return {
      countryCode: 'US',
      country: 'United States',
      currency: { code: 'USD', symbol: '$', name: 'US Dollar' }
    };
  }
};

// Get exchange rates silently
export const getExchangeRates = async (baseCurrency = 'USD') => {
  try {
    // Check cache
    if (exchangeRatesCache && Date.now() - ratesCacheTime < CACHE_DURATION) {
      return exchangeRatesCache;
    }

    const response = await fetch(`https://api.exchangerate-api.com/v4/latest/${baseCurrency}`);
    if (!response.ok) throw new Error('Failed to fetch rates');
    
    const data = await response.json();
    exchangeRatesCache = data.rates;
    ratesCacheTime = Date.now();
    
    return data.rates;
  } catch (error) {
    // Return cached or default rates
    return exchangeRatesCache || { USD: 1, EUR: 0.92, GBP: 0.79, NGN: 1550, JPY: 149, CNY: 7.2, INR: 83 };
  }
};

// Convert price between currencies (synchronous version with pre-fetched rates)
// Usage: convertPrice(amount, exchangeRates, targetCurrency)
// Where exchangeRates is an object like { USD: 1, NGN: 1550, EUR: 0.92, ... }
export const convertPrice = (amount, exchangeRates, targetCurrency) => {
  // If no conversion needed or invalid input
  if (!amount || !targetCurrency || targetCurrency === 'USD') return amount;
  if (!exchangeRates || typeof exchangeRates !== 'object') return amount;
  
  // Get rate for target currency (rates are relative to USD)
  const rate = exchangeRates[targetCurrency] || 1;
  
  // Convert from USD to target currency
  const convertedAmount = amount * rate;
  
  return Math.round(convertedAmount * 100) / 100;
};

// Async version for when rates need to be fetched
export const convertPriceAsync = async (amount, fromCurrency, toCurrency) => {
  if (fromCurrency === toCurrency) return amount;
  
  const rates = await getExchangeRates('USD');
  
  // Convert to USD first, then to target
  const usdAmount = fromCurrency === 'USD' ? amount : amount / (rates[fromCurrency] || 1);
  const convertedAmount = toCurrency === 'USD' ? usdAmount : usdAmount * (rates[toCurrency] || 1);
  
  return Math.round(convertedAmount * 100) / 100;
};

// Format price with currency symbol
export const formatPrice = (amount, currencyCode) => {
  const currencyInfo = ALL_CURRENCIES[currencyCode];
  const symbol = currencyInfo?.symbol || currencyCode;
  const decimals = currencyInfo?.decimals ?? 2;
  
  const formatted = amount.toLocaleString(undefined, { 
    minimumFractionDigits: decimals, 
    maximumFractionDigits: decimals 
  });
  
  return `${symbol}${formatted}`;
};

// Get currency for a country code
export const getCurrencyForCountry = (countryCode) => {
  return CURRENCY_BY_COUNTRY[countryCode] || { code: 'USD', symbol: '$', name: 'US Dollar' };
};

// Check if gateway supports a currency
export const gatewayAcceptsCurrency = (gatewaySlug, currencyCode) => {
  const supported = GATEWAY_CURRENCIES[gatewaySlug];
  return supported ? supported.includes(currencyCode) : false;
};

// Get the best currency to send to a gateway
export const getBestCurrencyForGateway = (gatewaySlug, billingCountryCode) => {
  // Paysafe always uses NGN
  if (gatewaySlug === 'paysafe') return 'NGN';
  
  // Nigeria always uses NGN for Nigerian gateways
  if (billingCountryCode === 'NG' && ['paystack', 'flutterwave', 'korapay', 'monnify'].includes(gatewaySlug)) {
    return 'NGN';
  }
  
  const billingCurrency = getCurrencyForCountry(billingCountryCode).code;
  
  // Check if gateway accepts billing currency
  if (gatewayAcceptsCurrency(gatewaySlug, billingCurrency)) {
    return billingCurrency;
  }
  
  // Fallback to USD
  return 'USD';
};

// Get all supported currencies for display
export const getAllSupportedCurrencies = () => {
  return Object.entries(ALL_CURRENCIES).map(([code, info]) => ({
    code,
    ...info
  }));
};
